<template>
	<span class="content">
		<ParsedMessage :network="network" :message="message" :text="errorMessage" />
	</span>
</template>

<script>
import ParsedMessage from "../ParsedMessage.vue";

export default {
	name: "MessageTypeError",
	components: {
		ParsedMessage,
	},
	props: {
		network: Object,
		message: Object,
	},
	computed: {
		errorMessage() {
			switch (this.message.error) {
				case "bad_channel_key":
					return `Vrejtje: ${this.message.channel} - Celsi i gabuar.`;
				case "banned_from_channel":
					return `Vrejtje: ${this.message.channel} - jeni i debuar nga kanali.`;
				case "cannot_send_to_channel":
					return `Nuk mund te dergoni/shkruani ne ${this.message.channel}`;
				case "channel_is_full":
					return `Vrejtje: ${this.message.channel} - Kanali eshte full.`;
				case "chanop_privs_needed":
					return "Nuk mund te perdorni: Ju duhet te jeni operator.";
				case "invite_only_channel":
					return `Vrejtje: ${this.message.channel} - kanali eshte vetem me ftese.`;
				case "no_such_nick":
					return `Personi ${this.message.nick} nuk eshte ketu ose eshte larguar.`;
				case "not_on_channel":
					return "Nuk mund te perdorni kete: Nuk jeni ne kete kanal.";
				case "password_mismatch":
					return "Password gabim.";
				case "too_many_channels":
					return `Vrejtje: ${this.message.channel} - Ju keni arritur limitin e kanaleve.`;
				case "unknown_command":
					return `Komande e gabuar: ${this.message.command}`;
				case "user_not_in_channel":
					return `Personi ${this.message.nick} Nuk eshte ne kanal.`;
				case "user_on_channel":
					return `Personi ${this.message.nick} eshte per moment ne kanal.`;
				default:
					if (this.message.reason) {
						return `${this.message.reason} (${this.message.error})`;
					}

					return this.message.error;
			}
		},
	},
};
</script>
